module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/arrow_under-b54670fd48d05ba35786e6fd9334ffd0.png";